import { Link } from "react-router-dom";
import logo from "@/assets/fanpictor-logo-white.png";

const FanpictorLogo = () => (
  <Link to="/" aria-label="Fanpictor fan engagement platform">
    <img src={logo} alt="Fanpictor fan engagement platform" className="h-11 md:h-12 w-auto object-contain" />
  </Link>
);

export default FanpictorLogo;
